import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import {Query} from 'react-apollo';
import {posts} from '../../../../data/stackups/queries';
import {Spinner} from '../../../tool-profile/components/shared/styles';
import Circular, {LARGE} from '../../../../shared/library/indicators/indeterminate/circular';
import {flattenEdges} from '../../../../shared/utils/graphql';
import BlogPost from '../../../../shared/library/cards/blogpost';
import {MobileContext} from '../../../../shared/enhancers/mobile-enhancer';
import {updateQuery} from '../../utils';

const Posts = ({slug, currentUser}) => {
  const isMobile = useContext(MobileContext);
  return (
    <Query query={posts} variables={{slug, first: 8}} notifyOnNetworkStatusChange={true}>
      {({loading, data, fetchMore}) => {
        const hasData = data && data.stackupBySlug && data.stackupBySlug.featuredPosts;
        if (loading && !hasData)
          return (
            <Spinner>
              <Circular size={LARGE} />
            </Spinner>
          );

        if (hasData) {
          const postData = flattenEdges(data.stackupBySlug.featuredPosts);
          const endCursor = data.stackupBySlug.featuredPosts.pageInfo.endCursor;
          const hasNextPage = data.stackupBySlug.featuredPosts.pageInfo.hasNextPage;

          const onLoadMoreClick = () => {
            fetchMore({
              variables: {
                after: endCursor,
                first: isMobile ? 6 : 10
              },
              updateQuery
            });
          };

          if (postData && postData.length >= 1)
            return (
              <BlogPost
                posts={postData}
                title={'Blog Posts'}
                hasNextPage={hasNextPage}
                loadMore={onLoadMoreClick}
                loading={loading}
                currentUser={currentUser}
              />
            );
          else return null;
        } else {
          return null;
        }
      }}
    </Query>
  );
};

Posts.propTypes = {
  slug: PropTypes.string,
  currentUser: PropTypes.object
};

export default Posts;
